import CommonCreate from "@/components/common/Create"
import { useState } from "react"
import TaxiClientForm from "./ClientForm"

const ClientCreate = () => {
    const [formProp, setFormProp] = useState({
        name: "",
        phone_number: "",
        home_address: ""
    })

    return (
        <CommonCreate title="Create new client" data={formProp} resource="taxi-clients">
            <TaxiClientForm formProp={formProp} setFormProp={setFormProp} />
        </CommonCreate>
    )
}

export default ClientCreate